<script setup lang="ts">
import type { AssignmentTemplateListRow } from '../../../model/assignments/interfaces'

import { faTriangleExclamation } from '@fortawesome/pro-regular-svg-icons'

import { AppText } from '@shared/ui/typography'
import { AppTooltip } from '@shared/ui/tooltips'
import { AppBadge } from '@shared/ui/badges'

import { useAssignmentTaxonomy } from '../../../model/assignments/assignment-taxonomy.hook'

defineOptions({
  name: 'AssignmentTemplateTaxonomy',
})

const props = defineProps<{
  template: AssignmentTemplateListRow
}>()

const {
  refDisplayLabel,
  refLessonTitle,
  refLabel,
  refHasTopic,
  refIsStale,
  staleHint,
} = useAssignmentTaxonomy({
  template: computed(() => props.template),
})
</script>

<template>
  <div class="assignment-template-taxonomy">
    <AppTooltip
      v-if="refHasTopic"
      :text="refLabel ?? refDisplayLabel"
      placement="top"
    >
      <div class="assignment-template-taxonomy__lesson">
        <AppText
          name="body1-medium"
          :color="refIsStale ? 'slate-600' : 'slate-900'"
        >
          {{ refDisplayLabel }}
        </AppText>
        <AppText
          v-if="refLessonTitle"
          name="body2"
          :color="refIsStale ? 'slate-500' : 'slate-700'"
        >
          {{ refLessonTitle }}
        </AppText>
      </div>
    </AppTooltip>

    <!-- `curriculum_topic_id: null` is legal (decision 6) and must read as a state, not a gap. -->
    <AppText
      v-else
      name="body1"
      color="slate-400"
    >
      No topic
    </AppText>

    <!-- Decision 7: nothing re-tags a template automatically, so this badge is the only way an
         admin ever learns the curriculum moved out from under it. -->
    <AppTooltip
      v-if="refIsStale"
      :text="staleHint"
      placement="top"
    >
      <AppBadge
        color="amber"
        text="Needs re-tagging"
        :prepend-icon="faTriangleExclamation"
      />
    </AppTooltip>
  </div>
</template>

<style scoped lang="scss" src="./AssignmentTemplateTaxonomy.scss" />
